import { getEnvironmentApiUrls } from '@dvag/dfs-constant-config/api-urls';
import { FondCollectionItem } from '../../component/FundsModal/types';
import { Advisor } from '../../type/advisor';
import { versions } from './versions';
import { getApiClient } from './api-client';

export const advisorApi = () => {
  const baseURL = `${getEnvironmentApiUrls().advisor}/${versions.v4}`;
  const api = getApiClient(baseURL);

  const getAdvisorInformation = async () => api.get<Advisor>('/advisor');

  const getAllFunds = async () => api.get<FondCollectionItem[]>('/fonds/all');

  return {
    getAdvisorInformation,
    getAllFunds,
  };
};
